class CarouselSliderController {
  constructor($timeout) {
    'ngInject';
    this.slideCount = 0;

    Object.assign(this, {$timeout});

    // this.image = angular.element('.carousel__image');
  }

  $onInit () {
    this.data = this.data.map(v => v + '?' + (new Date()).getTime())
    this.slidesCount = this.data.length - 1
    this.$timeout(() => {
      const slideCount = $('#slider ul li').length;
      this.slideWidth = $('#slider ul li img').width();
      const slideHeight = $('#slider ul li img').height();
      const sliderUlWidth = slideCount * this.slideWidth;
      $('#slider').css({width: this.slideWidth, height: slideHeight});

      $('#slider ul').css({width: sliderUlWidth, marginLeft: -this.slideWidth});

      $('#slider ul li:last-child').prependTo('#slider ul');
    }, 300)
  }

  previous() {
    this.slideCount -= 1
    $('#slider ul').animate({
      left: + this.slideWidth
    }, 400, () => {
      $('#slider ul li:last-child').prependTo('#slider ul');
      $('#slider ul').css('left', '');
    });
  }

  next() {
    this.slideCount += 1
    $('#slider ul').animate({
      left: - this.slideWidth
    }, 400, () => {
      $('#slider ul li:first-child').appendTo('#slider ul');
      $('#slider ul').css('left', '');
    });
  }

  // animation(property) {
  //   const opacity = property === 'hide' ? 0 : 1;
  //   this.image.css({opacity: opacity, 'transition-duration': '0.5s'});
  // }
}

export default CarouselSliderController;



// WEBPACK FOOTER //
// ./client/app/components/carousel-slider/carousel-slider.controller.js